import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type { Entity } from '../../types'
import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.rule.DOC}
  mutation UpdateRateRule(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $id: ID!
    $updates: RateRuleUpdates!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                updateRule(id: $id, updates: $updates) {
                  ...FragmentRateRule
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.UpdateRateRuleMutation,
  Entity | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'rate',
            graphql.transformers.OUT.select(
              'updateRule',
              fragments.rule.TRANSFORMER,
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateRateRuleMutation,
  Entity | undefined,
  graphql.schema.UpdateRateRuleMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
